import styled from "styled-components";

const CardStyle = styled.div`
  background-color: lightskyblue;
  color: #282c34;
  padding-bottom: 15px;
  border-radius: 8px;
`;

export default CardStyle;
